const PAID_STATUSES = ['CONFIRMED', 'RECEIVED', 'CONCLUDED'];

export const DEFAULT_PROPOSAL_GATES = {
    skipContractSignature: false,
    skipPlanPayment: false,
    skipCustomizationPayment: false,
};

export function getProposalGates(contract) {
    const raw = contract?.contractData?.gates;
    return {
        ...DEFAULT_PROPOSAL_GATES,
        ...(raw && typeof raw === 'object' ? raw : {}),
        skipContractSignature: Boolean(raw?.skipContractSignature),
        skipPlanPayment: Boolean(raw?.skipPlanPayment),
        skipCustomizationPayment: Boolean(raw?.skipCustomizationPayment),
    };
}

function isPaidStatus(status) {
    return PAID_STATUSES.includes(status);
}

function isCustomPaid(contract) {
    const order = contract?.customizationOrder || contract?.Order?.Suborders?.[0];
    if (!order?.Order_products?.length) return true;
    if (Number(order.total ?? 0) === 0) return true;
    return isPaidStatus(order.paymentStatus);
}

/**
 * Upgrade: o admin aplica no clube quando os gates (ou as etapas reais) estiverem ok.
 */
export function getUpgradeApplyReadiness(contract) {
    const gates = getProposalGates(contract);
    const alreadyApplied = Boolean(contract?.contractData?.upgradeAppliedAt);

    const signatureOk = gates.skipContractSignature || Boolean(contract?.signedAt);
    const subscription = contract?.subscription || contract?.Subscription?.[0];
    const planOk =
        gates.skipPlanPayment ||
        !contract?.planId ||
        (subscription && isPaidStatus(subscription.paymentStatus));
    const customOk = gates.skipCustomizationPayment || isCustomPaid(contract);

    const missing = [];
    if (!signatureOk) missing.push('contrato assinado');
    if (!planOk) missing.push('plano pago/confirmado');
    if (!customOk) missing.push('customização paga/confirmada');

    return {
        alreadyApplied,
        canApply: Boolean(contract?.clubId) && !alreadyApplied && signatureOk && planOk && customOk,
        missing,
        skips: {
            signature: gates.skipContractSignature,
            plan: gates.skipPlanPayment,
            custom: gates.skipCustomizationPayment,
        },
    };
}

/**
 * Proposta pronta para criar clube (respeita gates).
 */
export function isProposalReadyForClub(contract) {
    if (!contract || contract.clubId) return false;

    const gates = getProposalGates(contract);

    const signatureOk = gates.skipContractSignature || Boolean(contract.signedAt);

    const subscription = contract.subscription || contract.Subscription?.[0];
    const planOk =
        gates.skipPlanPayment ||
        !contract.planId ||
        (subscription && isPaidStatus(subscription.paymentStatus));

    const custOrder = contract.customizationOrder || contract.Order?.Suborders?.[0];
    const hasCustProducts =
        (custOrder?.Order_products?.length ?? 0) > 0 ||
        (Array.isArray(contract.contractData?.customProducts) && contract.contractData.customProducts.length > 0);
    const custOk =
        gates.skipCustomizationPayment ||
        !hasCustProducts ||
        !custOrder ||
        Number(custOrder.total ?? 0) === 0 ||
        isPaidStatus(custOrder.paymentStatus);

    return signatureOk && planOk && custOk;
}
